import EmailIcon from  '../../globals/images/icon-email-green.svg'
import PhoneIcon from  '../../globals/images/icon-phone.svg'
import { PropTypes } from 'prop-types'
export const EmptyFactors = ( { webId, type, factor, onAddClick }  ) => {

    const handleFactorAddClick = () => {
        onAddClick( factor )
    }

    const renderComponent = () =>{
        const verificationText = type=='Email'? 'Email Verification':'Text Message Verification' 
        return <>
            <div data-testid={ type=='Email' ? 'emailEmptyFactor' : 'smsEmptyFactor' }  className='factors-row  order-6'>
                <img src={ ( type=='Email'? EmailIcon:PhoneIcon ) } alt={ type+' Icon' } className={ 'svg-'+type }/>
                <span aria-label={ verificationText }> {verificationText}</span>
                <button id='dt-mfa-add' tabIndex= { 0 } data-testid="addFactor-btn" aria-label={ type=='Email' ? 'Add Email verification' : 'Add SMS verification' } className='add-factor u-btn-clear' onClick={ () => handleFactorAddClick() }>Add</button>
            </div>
        </>
    }

    return <>{renderComponent()}</>
}
EmptyFactors.propTypes = {
    webId: PropTypes.string,
    type:PropTypes.string.isRequired,
    factor:PropTypes.number.isRequired,
    onAddClick:PropTypes.func
}